export type CriteriaPrimitive = string | number | boolean;
export type CriteriaValue = CriteriaPrimitive | undefined | null;

export interface Criteria {
    value: CriteriaValue;
    must?: CriteriaPrimitive;
    oneOf?: CriteriaPrimitive[];
    anyCase?: boolean;
}

function isNullOrUndefined(v: unknown): v is undefined | null {
    return v === undefined || v === null;
}

function validateCriteria(c: Criteria): boolean {
    // if must is provided, require strict equality
    if (!isNullOrUndefined(c.must)) {
        if (c.anyCase && typeof c.value === 'string' && typeof c.must === 'string') {
            return c.value.toLocaleLowerCase() === c.must.toLocaleLowerCase();
        }

        return c.value === c.must;
    }

    if (Array.isArray(c.oneOf)) {
        if (c.oneOf.length === 0) {
            return false;
        }

        return c.oneOf.some((option) => {
            if (c.anyCase && typeof c.value === 'string' && typeof option === 'string') {
                return c.value.toLocaleLowerCase() === option.toLocaleLowerCase();
            }

            return c.value === option;
        });
    }

    return true;
}

/**
 * validateCriteria returns true only when all criteria are satisfied.
 * If criteria is empty or undefined, it returns true.
 */
export function validateAllCriteria(criteria: Criteria[]): boolean {
    if (criteria.length === 0) {
        return true;
    }
    return criteria.every(validateCriteria);
}
